import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '@store/reducers';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';

/**
 * Provide Authentication information in HTTP requests.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _store: Store<fromRoot.State>) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let newReq = req;

    // Get OAuth token.
    this._store.pipe(select(fromRoot.getAuthData)).subscribe(authData => {
      // Set the Bearer token if we have it and ONLY if the URL is going to our WebAPI server!!!
      if (
        authData &&
        !String.isNullOrWhitespace(authData.token) &&
        req.url
          .toLowerCase()
          .startsWith(environment.webApi_UrlRoot.toLowerCase())
      ) {
        newReq = req.clone({
          setHeaders: {Authorization: 'Bearer ' + authData.token},
          withCredentials: true
        });
      }
    });

    return next.handle(newReq);
  }
}
